import { Box } from '@squareup/dex-ui-shared-base';
import { MarkdownLink } from '@squareup/dex-ui-shared-markdown-components';
import React, { FC, PropsWithChildren, ReactNode } from 'react';

import styles from './product-showcase.module.css';

interface MdxProductShowcaseProps {
  // JSX element passed from MDX, typically `<img src="…" alt="…" />`.
  // The lowercase `img` MDX mapping rewrites this through MdxMdxImage so
  // asset paths and alt text already match the rest of the page.
  image?: ReactNode;
  // CTA label and target. Fern allows both to be empty strings on pages
  // that use ProductShowcase purely for the image+text layout (see
  // in-person-payment-options.mdx), so we skip rendering the link when
  // either is falsy rather than producing an `href=""` anchor.
  linkText?: string;
  linkUrl?: string;
}

const MdxProductShowcase: FC<PropsWithChildren<MdxProductShowcaseProps>> = ({
  image,
  linkText,
  linkUrl,
  children,
}) => {
  const showLink = Boolean(linkText && linkUrl);

  return (
    <Box margin={{ vertical: '3x' }}>
      <div className={styles.container}>
        <div className={styles['text-column']}>
          {children}
          {showLink && (
            <div>
              <MarkdownLink href={linkUrl as string}>{linkText} →</MarkdownLink>
            </div>
          )}
        </div>
        <div className={styles['image-column']}>{image}</div>
      </div>
    </Box>
  );
};

MdxProductShowcase.displayName = 'MdxProductShowcase';

export { MdxProductShowcase };
